const MS_PER_MINUTE = 60 * 1000
const MS_PER_HOUR = MS_PER_MINUTE * 60
const MS_PER_DAY = MS_PER_HOUR * 24
const MS_PER_WEEK = MS_PER_DAY * 30

export function timeAgo(current: Date, previous: Date) {
  const elapsed = current.getTime() - previous.getTime()
  const words = msToWords(elapsed)
  if (words) {
    return `${words} ago`
  }
  return previous.toISOString().split('T')[0] // yyyy-mm-dd
}

export function timeLeft(current: Date, future: Date) {
  const remaining = Math.max(future.getTime() - current.getTime(), 0)
  const words = msToWords(remaining)
  if (words) {
    return words
  }
  return future.toISOString().split('T')[0] // yyyy-mm-dd
}

function msToWords(ms: number) {
  if (ms < MS_PER_MINUTE) {
    return getPluralOrSingular(Math.round(ms / 1000), 'sec')
  } else if (ms < MS_PER_HOUR) {
    return getPluralOrSingular(Math.round(ms / MS_PER_MINUTE), 'min')
  } else if (ms < MS_PER_DAY) {
    return getPluralOrSingular(Math.round(ms / MS_PER_HOUR), 'hr')
  } else if (ms < MS_PER_WEEK) {
    return getPluralOrSingular(Math.round(ms / MS_PER_DAY), 'day')
  }
}

function getPluralOrSingular(value: number, word: string) {
  return `${value} ${value === 1 ? word : word + 's'}`
}
